/**
 * Dynamically intialize the `home-header-slider`'s.
 * It will use the options in the `data-slider-options`.
 */
function msInitializeBoatSlider() {
    const lastMinuteBoatSlider = new Swiper(`.last-minute-boat-slider`, {
        loop: true,
        loopedSlides: 0,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: { delay: 5000 },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            'nextEl': '.swiper-button-next',
            'prevEl': '.swiper-button-prev',
        },
    });
}

document.addEventListener(`DOMContentLoaded`, function() {
    msInitializeBoatSlider();
});

if (typeof acf !== "undefined") {
    acf.addAction(`render_block_preview`, function($el, attributes) {
        msInitializeBoatSlider();
    });
}
